const CircularProgress = ({ pending, total }) => {
  const strokeDasharray = 94; // Approximate perimeter for r=15 circle
  const strokeDashoffset = (strokeDasharray * (1 - pending / total)).toFixed(2);

  return (
    <div className="flex justify-center w-full">
      <div className="relative w-24 h-24 xs:w-28 xs:h-28 sm:w-32 sm:h-32">
        <svg className="w-full h-full" viewBox="0 0 36 36">
          {/* Background Circle */}
          <circle
            className="text-gray-200 stroke-current"
            strokeWidth="4"
            cx="18"
            cy="18"
            r="15"
            fill="none"
          />
          {/* Progress Circle */}
          <circle
            className="text-red-500 stroke-current"
            strokeWidth="4"
            strokeDasharray={strokeDasharray}
            strokeDashoffset={strokeDashoffset}
            cx="18"
            cy="18"
            r="15"
            fill="none"
            strokeLinecap="round"
          />
        </svg>
        {/* Text Centered */}
        <div className="absolute inset-0 flex flex-col items-center justify-center text-lg font-bold">
          <span>
            {pending}/{total}
          </span>
          <p className="text-sm font-semibold text-gray-700">Pending</p>
        </div>
      </div>
    </div>
  );
};

export default CircularProgress;
